var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    "data-name": "Calque 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc6d26;}.cls-2{fill:#e24329;}.cls-3{fill:#fca326;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter copie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-1",
    d: "M20.81,13.22l-1-3.06-2-6.08a.34.34,0,0,0-.43-.22.35.35,0,0,0-.21.22l-2,6.07H8.67l-2-6.07a.34.34,0,0,0-.43-.22.35.35,0,0,0-.21.22l-2,6.07-1,3.07a.68.68,0,0,0,.25.76L12,20.25,20.56,14a.68.68,0,0,0,.25-.76"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-2",
    d: "M12,20.24h0l3.27-10.09H8.67Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "cls-1",
    d: "M12,20.24,8.67,10.15H4.08Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    className: "cls-3",
    d: "M4.07,10.16h0l-1,3.06a.69.69,0,0,0,.24.76L12,20.25Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    className: "cls-2",
    d: "M4.08,10.16H8.67l-2-6.08a.33.33,0,0,0-.43-.21.32.32,0,0,0-.21.21Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    className: "cls-1",
    d: "M12,20.24l3.27-10.09h4.6Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    className: "cls-3",
    d: "M19.81,10.16h0l1,3.06a.69.69,0,0,1-.24.76L12,20.24l7.86-10.08Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    className: "cls-2",
    d: "M19.82,10.16h-4.6l2-6.08a.33.33,0,0,1,.43-.21.32.32,0,0,1,.21.21l2,6.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.74aef81966df78742d8e2d7826310fa6.svg";
export { ForwardRef as ReactComponent };